export default "__VITE_ASSET__CnWRyUcK__"